import { BarChartDataItem } from 'plume-ui/dist/utils/charts/chartTypes';
import { SBPieData } from '../graphTypes';
import { HealthScoreStat } from '../types';

export const isPieEmpty = (pie: SBPieData[]) => {
  if (!Array.isArray(pie) || !pie.length) return true;
  for (const slice of pie) {
    if (isNaN(slice.count as number)) return true;
    if (slice.count !== 0) return false;
  }
  return true;
};

export const prepareNetworkHealthData = (
  partnerData: HealthScoreStat,
  baselineData: HealthScoreStat,
  locationsCount: number,
): BarChartDataItem[] => {
  //@ts-ignore
  const keys: (keyof HealthScoreStat)[] = Object.keys(partnerData);
  const baselineLocationsCount = keys
    .map((key) => baselineData[key])
    .reduce((acc, curr) => (acc += curr));
  const ratio = locationsCount / baselineLocationsCount;
  return keys.map((key) => ({
    name: `${key}`,
    values: [partnerData[key], Math.round(baselineData[key] * ratio)],
  }));
};
